/*
 * LocaleToggle Messages
 *
 * This contains all the text for the LanguageToggle component.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.LocaleToggle';

export default defineMessages({
  id: {
    id: `${scope}.id`,
    defaultMessage: 'id',
  },
  en: {
    id: `${scope}.en`,
    defaultMessage: 'en',
  },
});



// WEBPACK FOOTER //
// ./src/components/LocaleToggle/messages.js